import { render, staticRenderFns } from "./customerscore-add-or-update.vue?vue&type=template&id=7c571289&scoped=true&"
import script from "./customerscore-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customerscore-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./customerscore-add-or-update.vue?vue&type=style&index=0&id=7c571289&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c571289",
  null
  
)

export default component.exports